import { gql } from '@apollo/client'

const SIMPLE_ALLERGEN_FRAGMENT = gql`
  fragment SimpleAllergenFragment on Allergen {
    id
    name
    isCurationEnabled
    position
  }
`

export default SIMPLE_ALLERGEN_FRAGMENT
